import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {CSSProperties} from 'react'
import {Checkbox} from '../Components/Checkbox'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router';
import Radium, { StyleRoot } from 'radium'

let wrapperStyle: CSSProperties = {
    fontFamily: 'CenturyGothic',
    fontSize: '18px',
    textTransform: 'uppercase',
    maxWidth: '700px',
    alignSelf: 'center',
    margin:'35px auto 10px auto',
    '@media (max-width:414px)': {
        fontSize:'11px',
        width:'95%'
    },
    '@media (max-width:412px)': {
        fontSize:'9px'
    },
    '@media (max-width:375px)': {
        fontSize:'9px',
    },
    '@media (max-width:360px)': {
        fontSize:'7px'
    },
    '@media (max-width:320px)': {
        fontSize:'8px'
    }
}
let subheadStyle: CSSProperties = {
    letterSpacing: '0.3em',
    fontSize: '15px',
    display: 'flex',
    alignSelf: 'center',
    color:'#323232',
    fontFamily:'BarlowLight'
}
let loginStyle: CSSProperties = {
    letterSpacing: '3px',
    fontSize: '12px',
    display: 'flex',
    alignSelf: 'center',
    cursor: 'pointer'
}
let rowStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}
let rowWithCheckStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
}
let labelStyle: CSSProperties = {
    letterSpacing: '1px',
    display: 'flex',
    alignSelf: 'flex-start',
    fontWeight: 100,
    margin: 0,
    color: Tgcc.Styles.darkTextColor,
    lineHeight: '35px',
    fontFamily: 'Lulo',
}
let inputStyle: CSSProperties = {
    display: 'flex',
    flexGrow: 2,
    marginLeft: '6px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '35px',
    border:'2px solid #E9E6E6',
    fontFamily:'BarlowLight',
    backgroundColor:'white',
    color:'rgb(97, 96, 96)',
    '@media (max-width:414px)': {
        lineHeight:'25px'
    }
}
let checkStyle: CSSProperties = {
    display: 'flex',
    marginLeft: '8px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '20px',
    width: '20px',
    alignSelf: 'center',
    border:'2px solid #E9E6E6',
    fontFamily:'BarlowLight',
    '@media (max-width:414px)': {
        lineHeight:'25px',
        height: '15px',
        width: '15px'
    }
}
let fieldBoxStyle: CSSProperties = {
    paddingTop: '15px',
    paddingBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
}

let checkCont: CSSProperties = {
    display:'inline-block'
}
let checkCont1 = Object.assign({},checkCont,{marginRight:'100px'});

let inHandsNote: CSSProperties = {
    fontFamily:'BarlowLight',
    color:'rgba(66, 66, 66, 0.8)',
    margin:'auto',
    letterSpacing:'1px',
    cursor:'pointer',
    ':hover': {
        textDecoration:'underline'
    }
}
const currentTurnaround: CSSProperties = {
    color:'red',
    fontFamily:'BarlowMedium',
    fontSize:'18px',
    textAlign:'center'
}
class ProofInfoState {
    proof: Tgcc.Proof;
    user: Tgcc.UserInfo;
    password: string;
    confirmPassword: string;
    Embroidery: boolean;
    ScreenPrint: false;
}

let stateStyle = Object.assign({}, inputStyle, { width: "40px", flexGrow: "0", textTransform: "uppercase"});
let zipStyle = Object.assign({}, inputStyle, { width: "100px", flexGrow: "0",'@media(max-width:375px':{width:"80px"},'@media(max-width:320px)':{width:"75px"}});
let passInput = Object.assign({}, inputStyle, { '@media(max-width:375px)': {width:'40px'}});
let nameStyle = Object.assign({}, inputStyle, {'@media(max-width:375px)': {flexGrow:1},'@media(max-width:360px)':{width:'125px'}, '@media(max-width:320px)': { width:'100px'}});

const  isBlankOrEmpty = (str: string) => {
    if(!str)
        return true;
    if(!str.trim())
        return true;
    return false;
}
class _MajorAccountsproofInfo extends React.Component<Tgcc.BaseProps, any>{

    state: ProofInfoState = new ProofInfoState;

    openShipping = () => {browserHistory.push(Tgcc.Routes.MajorAccountShipping)};

    componentWillMount(){
        this.loadState(this.props);
    }

    componentWillReceiveProps(newProps: Tgcc.BaseProps){
        this.loadState(newProps);
        this.state.proof.phone = this.state.user.phone;
        this.state.proof.smsAllowed = this.state.user.smsAllowed;
    }

    loadState = (newProps: Tgcc.BaseProps) => {
        this.setState({
            proof: newProps.state.ActiveProof,
            user: newProps.state.UserInfo
        });
    }

    proofDataChanged = (evt: React.FormEvent<HTMLInputElement>) =>{
        var proof = this.state.proof;
        var name = evt.currentTarget.name;
        if(name == 'SmsAllowed' )
            proof[name] = evt.currentTarget.checked;
        else
            proof[name] = evt.currentTarget.value;
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof})
    }
    phoneSMSChanged = (evt: React.FormEvent<HTMLInputElement>) =>{
        var proof = this.state.proof;
        var name = evt.currentTarget.name;
        if(name == 'smsAllowed' )
            proof[name] = evt.currentTarget.checked;
        else
            proof[name] = evt.currentTarget.value;
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof})
    }
    proofPhoneChanged = (evt: React.SyntheticEvent<HTMLInputElement>) =>{
        var proof = this.state.proof;
        proof.phone = evt.currentTarget.value;
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof})  
    }
    

    screenPrintChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var proof = this.state.proof;
        proof.screenPrint = evt.currentTarget.checked
        console.log(evt.currentTarget.checked)
        
        if(evt.currentTarget.checked){
            document.getElementById("embroidery")["disabled"] = true;
        } else {
            document.getElementById("embroidery")["disabled"] = false;
        }
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof});
    }
    embroideryChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var proof = this.state.proof;
        proof.embroidery = evt.currentTarget.checked
        console.log(evt.currentTarget.checked)
        if(evt.currentTarget.checked){
            document.getElementById("screenPrint")["disabled"] = true;
        } else {
            document.getElementById("screenPrint")["disabled"] = false;
        }
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof});

    }

    render(){
        var proof: Tgcc.Proof = this.state.proof;
        console.log(proof);
        var loginSuggestion = null, passwordPrompt = null; 
        var loginData = this.props.state.LoginData;
        var userInfo = this.props.state.UserInfo;
     

        return (
            <div style={wrapperStyle} className="campusProofInfo">
                <div style={fieldBoxStyle}>
                    <div style={subheadStyle} className="corpProfText">First, tell us about your project</div>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Project:</label>
                        <input type='text' style={inputStyle} name='eventName' onChange={this.proofDataChanged} value={proof.eventName||""} placeholder="Name Your Project"/>
                    </div>
                    <div style={rowStyle}>
                        <div style={checkCont}><Checkbox id="screenPrint" onChange={this.screenPrintChanged} name="cbScreenPrint" label="Screen printing" checked={proof.screenPrint || this.state.ScreenPrint} value={"ScreenPrint"} fontFamily="Lulo"/></div>
                        <div style={checkCont1} className="corpEmbChk"><Checkbox id="embroidery" onChange={this.embroideryChanged} name="cbEmbroidery" label="Embroidery" checked={this.state.Embroidery} value={"Embroidery"} fontFamily="Lulo" /></div>
                    </div>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Estimate Order Quantity:</label>
                        <input type='number' style={inputStyle} placeholder='Minimum of 36' name='orderSize' onChange={this.proofDataChanged} value={proof.orderSize||""}/>
                    </div>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Estimate In Hands Date:</label>
                        <input type='date' style={inputStyle} name='inHandsDate' placeholder="01/02/1990" onChange={this.proofDataChanged} value={proof.inHandsDate || ""}/>
                    </div>
                    <div style={currentTurnaround}>**Please be aware that our stated shipping date refers to the scheduled date the apparel will ship from our production facility in Liberty, SC. Due to ongoing Fedex shipping delays, the actual delivery date is beyond our control. Please consider allowing additional transit days if a critical delivery date is necessary or contact our sales department for expedited shipping options.**</div>
                    <div style={rowStyle}>
                        <div style={inHandsNote} onClick={this.openShipping}>Click here for turnaround times</div>
                    </div>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Contact Phone:</label>
                        <input type='text' style={inputStyle} name='phone' onChange={this.proofPhoneChanged} value={proof.phone} />
                    </div>
                    <div style={rowWithCheckStyle}>
                        <label className="labelStyle" style={labelStyle}>Receive text notifications:</label>
                        <input type='checkbox' style={checkStyle} name='smsAllowed' onChange={this.phoneSMSChanged} checked={proof.smsAllowed}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state,
            Embroidery: state.ActiveProof.embroidery,
            ScreenPrint: state.ActiveProof.screenPrint,
            Phone:state.ActiveProof.phone
        }
};
export var MajorAccountsProofInfo = connect(mapStateToProps)(Radium(_MajorAccountsproofInfo));
